import { memo, useMemo } from 'react';
import { Select } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { type VariantInfo, VariantInfoValueStatuses } from '../../../../api/variants';

const PLACEHOLDER = 'Выберите один из вариантов';

interface SelectCharacteristicProps extends TestProps {
    characteristic: VariantInfo;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export const SelectCharacteristic = memo(function SelectCharacteristic({
    'data-testid': dataTestId = 'SelectCharacteristic',
    characteristic,
    onChange,
    disabled = false,
}: SelectCharacteristicProps) {
    const { values, selected_value: value } = characteristic;

    const disabledKeys = useMemo(
        () =>
            values.reduce<Array<string>>((prev, cur) => {
                if (cur.status === VariantInfoValueStatuses.UNAVAILABLE) {
                    return [...prev, cur.value];
                }

                return prev;
            }, []),
        [values]
    );

    return (
        <Select
            data-testid={dataTestId}
            size="m"
            color="contour"
            width="max"
            value={value}
            items={values.map((option) => {
                return { value: option.value, content: option.value };
            })}
            placeholder={PLACEHOLDER}
            isDisabled={disabled}
            onChange={onChange}
            disabledKeys={disabledKeys}
            aria-label={`Выбрать характеристику ${value}`}
        />
    );
});
